import "core-js/actual/array/at";
import "core-js/actual/object/has-own";
import "core-js/actual/promise/all-settled";
import "core-js/actual/promise/any";
import "core-js/actual/string/at";
import "core-js/actual/string/replace-all";

export default defineNuxtPlugin(() => {});
